import React from 'react';
import Testimonial from '../../assets/images/mids.jpeg'

const TestimonialSection = () => {
  return (
    <section data-aos='fade-right' data-aos-duration='1500' id='testimonial' className="bg-[#101f3c] py-12 pt-10 pb-10">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-headingColor text-[2rem] font-[800] mb-2 ">
            Testimonials
          </h2>
          <div className="rounded-lg  p-6">
            <div className="mb-4">
              <div className="flex items-center justify-center">
                <img
                  src={Testimonial}
                  alt="Testimonial Person"
                  className="w-16 h-16 rounded-full mr-4"
                />
                <p className="lg:max-[600px] lg:max-auto text-smallTextColor font-semibold text-[16px] leading-7">
                As his TM, I have witnessed tremendous growth in his coding skills and ability to tackle complex problems with creativity and determination.
                </p>
              </div>
            </div>
            <div className="text-small pt-5 text-smallTextColor">
              <p>Hamida Mstafa | Technical Mentor | Moringa School</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialSection;
